module.exports = __webpack_public_path__ + "img/banner-index-1.27d0c395.jpg";